import { RECEIVE_MY_SUBSIDIARIES, SET_CURRENT_SUBSIDIARY } from '../actions/currentUser-actions.js'

const subsidiaries = (state = { subsidiaries: [], currentSubsidiary: undefined}, action) => {
  switch(action.type) {
    case RECEIVE_MY_SUBSIDIARIES: return {...state, subsidiaries: action.results }
    case SET_CURRENT_SUBSIDIARY: return {...state, subsidiary: action.subsidiary }
    default: return state
  }
}

export default subsidiaries
